/**
 * Small helpers behind the ingredient pack-size screens: the price-sanity
 * threshold and the number formatting the converter and readouts share. The
 * grid's own arithmetic lives in `conversion-grid.ts`.
 */

/** The ">25% either direction" threshold behind the price-sanity warning. */
export function isPriceSuspicious(current: number, previous: number): boolean {
  if (!isFinite(current) || !isFinite(previous) || previous <= 0 || current <= 0) return false;
  const ratio = current / previous;
  return ratio > 1.25 || ratio < 1 / 1.25;
}

export function formatNumber(value: number, maxFractionDigits = 2): string {
  if (!isFinite(value)) return "—";
  return value.toLocaleString("en-US", { maximumFractionDigits: maxFractionDigits });
}

export function formatMoney(value: number | null | undefined): string {
  if (value == null || !isFinite(value)) return "—";
  if (value >= 1) return `$${value.toFixed(2)}`;
  // Sub-cent unit costs ($0.0031/g) round to nothing at 2 decimals, so a very
  // small value keeps three significant figures instead.
  return `$${parseFloat(value.toPrecision(3))}`;
}
